<template>
    <div class="location-buttons">
        <v-btn color="primary" outline round @click="handleBack()">Back</v-btn>
        <v-btn v-if="href && text" color="primary" outline round @click="handleNext()">{{text}}</v-btn>
        <slot></slot>
        <!--<router-link :to="href" class="button">{{text}}</router-link>-->
    </div>
</template>

<script>
export default {
  name: 'locationButtons',
  props: {
    // Without href and text only the Back button is shown.
    href: {type: String},
    text: {type: String}
  },
  methods: {
    handleBack () {
      history.back()
    },
    handleNext() {
      this.$router.push(this.href)
    }
  }
}
</script>

<style scoped>
    .location-buttons {
        padding: 10px 0 0 27px;
    }
</style>



// WEBPACK FOOTER //
// src/globals/locationButtons.vue